import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { SubHeading } from '@widgets/BasketList/BasketItem/components/Unit/styles/wrapper';
import QuestionItem from '@widgets/SteppedQuiz/components/QuestionItem';
import { configureStore } from '@reduxjs/toolkit';
import { storeOptions } from '@widgets/SteppedQuiz/store';
import { Provider } from 'react-redux';
import { getCurrentQuestion, getLastItemInHistory, getQuestions, removeLastQuestionFromHistory, setCurrentQuestionFromId, setQuestionList, } from '@widgets/SteppedQuiz/store/reducers/question';
import { useAppDispatch, useAppSelector } from '@widgets/SteppedQuiz/store/hooks';
import { useEffect } from 'preact/compat';
import { Back, BackButton } from '@membershipForm/components/QuestionHeader/styles';
import { Header, Title, Wrapper, SmallContainer, Background, } from './styles';
function Quiz(props) {
    const { header, questions } = props;
    const { title, copy } = header;
    const dispatch = useAppDispatch();
    // set initial question list
    useEffect(() => {
        dispatch(setQuestionList(questions));
    }, []);
    const currQuestion = useAppSelector(getCurrentQuestion);
    const currQuestions = useAppSelector(getQuestions);
    const lastQuestionInHistory = useAppSelector(getLastItemInHistory);
    if (currQuestions.length === 0) {
        return null;
    }
    return (_jsxs(Wrapper, { className: "section section--dark", children: [_jsx(Background, {}), _jsxs(SmallContainer, { children: [_jsxs(Header, { children: [lastQuestionInHistory !== undefined && (_jsx(BackButton, { type: "button", onClick: () => {
                                    dispatch(removeLastQuestionFromHistory());
                                    if (lastQuestionInHistory) {
                                        dispatch(setCurrentQuestionFromId(lastQuestionInHistory));
                                    }
                                }, children: _jsx(Back, { children: _jsx("use", { xlinkHref: "#icon--chevron-breadcrumbs" }) }) })), _jsx(Title, { children: title }), copy && _jsx(SubHeading, { children: copy })] }), currQuestion && (_jsx(QuestionItem, { ...currQuestion }))] })] }));
}
function SteppedQuiz(props) {
    const { dataset } = props;
    const data = convertDataAttributes(dataset ?? {});
    const store = configureStore(storeOptions);
    return (_jsx(Provider, { store: store, children: _jsx(Quiz, { ...data }) }));
}
export default SteppedQuiz;
